module.exports = __webpack_public_path__ + "static/media/dd8.6262e789.jpg";